import { MiniRuleData } from '@/src/types/flight'
import { TranslationFunction } from '@/src/types/translations'
import { getBrandName } from '@/src/utils/buildUtils'
import { Box, Typography } from '@mui/material'

interface FareRulesSectionProps {
    miniruleData: MiniRuleData | undefined
    formatCurrency: (price: number) => string
    tFlightDetails: TranslationFunction<'srpFlightDetails'>
}

export const FareRulesSection: React.FC<FareRulesSectionProps> = ({ miniruleData, formatCurrency, tFlightDetails }) => {
    const airlineCancellationFee = miniruleData?.ADT?.BD?.C ? formatCurrency(Number(miniruleData?.ADT.BD.C)) : 'N/A'
    const airlineDateChangeFee = miniruleData?.ADT?.BD?.A ? formatCurrency(Number(miniruleData?.ADT.BD.A)) : 'N/A'
    const flyinCancellationFee = miniruleData?.ctc ? formatCurrency(Number(miniruleData?.ctc)) : 'N/A'
    const flyinDateChangeFee = miniruleData?.cta ? formatCurrency(Number(miniruleData?.cta)) : 'N/A'
    const brandName = getBrandName();
    return (
        <Box>
            <Box
                sx={{
                    backgroundColor: '#FFF',
                    display: 'flex',
                    borderTop: '1px solid',
                    borderColor: 'grey.200'
                }}
            >
                <Box
                    sx={{
                        pt: 3,
                        pl: 2,
                        pr: 1,
                        flex: 1,
                        borderRight: '1px solid',
                        borderColor: 'grey.200'
                    }}
                >
                    <Typography sx={{ fontWeight: 600, fontSize: { sm: 14, md: 16 } }}>
                        {tFlightDetails('cancellation')}
                    </Typography>
                </Box>

                <Box sx={{ flex: 2, py: 2, px: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                    <Box display="flex" justifyContent={'space-between'}>
                        <Typography variant="body2" color="grey.500" sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {tFlightDetails('airlineFee')}
                        </Typography>
                        <Typography variant="body2" fontWeight={500} sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {airlineCancellationFee}
                        </Typography>
                    </Box>
                    <Box display="flex" justifyContent={'space-between'}>
                        <Typography variant="body2" color="grey.500" sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {tFlightDetails(`${brandName}Fee`)}
                        </Typography>
                        <Typography variant="body2" fontWeight={500} sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {flyinCancellationFee}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    backgroundColor: '#FFF',
                    display: 'flex',
                    borderTop: '1px solid',
                    borderColor: 'grey.200'
                }}
            >
                <Box
                    sx={{
                        pt: 2,
                        pl: 2,
                        pr: 1,
                        flex: 1,
                        borderRight: '1px solid',
                        borderColor: 'grey.200'
                    }}
                >
                    <Typography sx={{ fontWeight: 600, fontSize: { sm: 14, md: 16 } }}>
                        {tFlightDetails('dateChange')}
                    </Typography>
                </Box>

                <Box sx={{ flex: 2, py: 2, px: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                    <Box display="flex" justifyContent={'space-between'}>
                        <Typography variant="body2" color="grey.500" sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {tFlightDetails('airlineFee')}
                        </Typography>
                        <Typography variant="body2" fontWeight={500} sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {airlineDateChangeFee}
                        </Typography>
                    </Box>
                    <Box display="flex" justifyContent={'space-between'}>
                        <Typography variant="body2" color="grey.500" sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {tFlightDetails(`${brandName}Fee`)}
                        </Typography>
                        <Typography variant="body2" fontWeight={500} sx={{ fontSize: { sm: 12, md: 14 } }}>
                            {flyinDateChangeFee}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
